var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoomOverlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3 13h5a1 1 0 010 2H2a.997.997 0 01-1-1V8a1 1 0 012 0v5zM13 3H8a1 1 0 010-2h6a1 1 0 011 1v6a1 1 0 01-2 0V3zM9 8a1 1 0 11-2.001-.001A1 1 0 019 8z",
    id: "zoom-overlay_svg__svg-node_modules/mrg-icons/src/mailru/navigation/zoom-overlay_svga"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zoom-overlay_svg__svg-node_modules/mrg-icons/src/mailru/navigation/zoom-overlay_svga",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogIDxkZWZzPgogICAgPHBhdGggZD0iTTMgMTNoNWExIDEgMCAwIDEgMCAySDJhLjk5Ny45OTcgMCAwIDEtMS0xVjhhMSAxIDAgMCAxIDIgMHY1ek0xMyAzSDhhMSAxIDAgMCAxIDAtMmg2YTEgMSAwIDAgMSAxIDF2NmExIDEgMCAwIDEtMiAwVjN6TTkgOGExIDEgMCAxIDEtMi4wMDEtLjAwMUExIDEgMCAwIDEgOSA4eiIgaWQ9Im5hdmlnYXRpb24tem9vbS1vdmVybGF5LWEiLz4KICA8L2RlZnM+CiAgPHVzZSB4bGluazpocmVmPSIjbmF2aWdhdGlvbi16b29tLW92ZXJsYXktYSIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";
export { SvgZoomOverlay as ReactComponent };